import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AuthState } from "../../../context/auth/auth/reducer";
import _environment from "../../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  className?: string;
}

const ProfileUserImage = ({ className, ...props }: Props) => {
  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [src, setSrc] = useState<string | undefined>(
    user?.profile_image_url || _environment.assets.userPlaceholder
  );

  const [error, setError] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Handle error image
   * @function
   */
  const onError = () => {
    if (!error) {
      setSrc(_environment.assets.userPlaceholder);
      setError(true);
    }
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Hook to user in order to set handle default image
   */
  useEffect(() => {
    if (!!user) {
      if (user.profile_image_url) {
        setSrc(user.profile_image_url);
      } else {
        setSrc(_environment.assets.userPlaceholder);
      }
    }
  }, [user]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return <img className="img-profile rounded-circle" alt="" src={src} onError={onError} />;
};
export default ProfileUserImage;
